import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import Swal from 'sweetalert2';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiServiceService {

  constructor(
    public http: HttpClient,
    private translate: TranslateService
  ) { }

  get(path: string, params?: HttpParams): Observable<any> {
    return this.http
      .get(`${path}`, { headers: this.setHeaders(), params })
      .pipe(
        catchError((er) => this.formatErrors(er)),
        map((res: any) => res)
      );
  }

  post(path: string, body: Object = {}): Observable<any> {
    return this.http.post(`${path}`, body).pipe(
      catchError((er) => this.formatErrors(er)),
      map((res: any) => res)
    );
  }

  update(path: string, body: any = {}): Observable<any> {
    body._method = "PUT";
    return this.http.post(`${path}`, body, { headers: this.setHeaders() }).pipe(
      catchError((er) => this.formatErrors(er)),
      map((res: any) => res)
    );
  }


  put(path: string, body: any = {}): Observable<any> {
    return this.http.put(`${path}`, body, { headers: this.setHeaders() }).pipe(
      catchError((er) => this.formatErrors(er)),
      map((res: any) => res)
    );
  }


  remove(path: string): Observable<any> {
    return this.http.delete(`${path}`, { headers: this.setHeaders() }).pipe(
      catchError((er) => this.formatErrors(er)),
      map((res: any) => res)
    );
  }

  getBlob(path: string, params?: HttpParams): Observable<HttpResponse<Blob>> {
    return this.http
      .get(`${path}`, {
        responseType: 'blob',
        observe: 'response'
      })
      .pipe(
        catchError((er) => this.formatErrors(er))
      );
  }

  getDownload(
    path: string,
    body: object = {}
  ): Observable<any> {
    // params['responseType'] = 'arraybuffer';
    // alert(path);
    return this.http
      .post(`${path}`, body, {
        headers: this.setHeadersWithFiles(),
        responseType: 'blob' as 'json',
      })
      .pipe(
        catchError((er) => this.formatErrors(er)),
        map((res: any) => res)
      );
  }


  downloadFile(path: any, model: any) {
    return this.getDownload(
      path,
      model
    )
      .pipe(catchError(this.handleError));
  }

  uploadFile(file: any, filePath: string) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('path', filePath);

    return this.http.post(`${environment.apiUrl}/recruitment/general/upload-file`, formData).pipe(
      catchError((er) => this.formatErrors(er)),
      map((res: any) => res)
    );
  }

  handleError(error: any) {
    return throwError(error);
  }

  private setHeadersWithFiles(): HttpHeaders {
    const headersConfig = {
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
      responseType: 'blob',
    };
    return new HttpHeaders(headersConfig);
  }


  private setHeaders(): HttpHeaders {
    const headersConfig = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };
    return new HttpHeaders(headersConfig);
  }

  private formatErrors(error: any) {
    let text = ''
    error?.errors.forEach((e: any) => {
      text += `<p>${e.massage}</p>`;
    });
    Swal.fire({
      title: this.translate.instant('swalMsg.Failed'),
      html: text,
      icon: 'error',
      confirmButtonText: this.translate.instant('swalMsg.Ok'),
    })
    return throwError(error);
  }

}
